import { render, staticRenderFns } from "./AppSlider.vue?vue&type=template&id=0353bd09&"
import script from "./AppSlider.vue?vue&type=script&lang=js&"
export * from "./AppSlider.vue?vue&type=script&lang=js&"
import style0 from "./AppSlider.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports